import actions from "./actions";

const initialState = {
  loading: false,
  list: {},
  bucketData: {},
  error: false,
  isBucketFetched: false,
  clearRangeLoading: false,
  lastClearAt: 0,
};

export default function bucketReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
